function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M7 17c-1.101 0-2-.9-2-2V3h10v14H7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M19 5v16H7"
  }));
};
export default SvgIconCopy;